export const API_HOST = import.meta.env.VITE_API_HOST;
export const API_PATH = "";
export const ALGOLIA_SEARCH_API_KEY = import.meta.env.VITE_ALGOLIA_SEARCH_API_KEY || "";
export const ALGOLIA_APPLICATION_ID = import.meta.env.VITE_ALGOLIA_APPLICATION_ID || "";
export const ALGOLIA_INDEX = import.meta.env.VITE_ALGOLIA_INDEX || "";
export const ALGOLIA_AUTHORITY_INDEX = import.meta.env.VITE_ALGOLIA_AUTHORITY_INDEX || "" ;
export const ALGOLIA_PROSECUTION_INDEX = import.meta.env.VITE_ALGOLIA_PROSECUTION_INDEX || "";
export const ALGOLIA_COURT_INDEX = import.meta.env.VITE_ALGOLIA_COURT_INDEX || "";
export const ALGOLIA_ORGANIZATION_INDEX = import.meta.env.VITE_ALGOLIA_ORGANIZATION_INDEX || "";
export const MERCURE_URL = import.meta.env.VITE_MERCURE_URL;
export const MERCURE_PREFIX = import.meta.env.VITE_MERCURE_PREFIX;
export const LEGALBIRD_BASE_URL = import.meta.env.VITE_LEGALBIRD_BASE_URL;
